export var Actions;
(function (Actions) {
    Actions["GET_LIST"] = "getDataSourceListAction";
    Actions["GET_DATA_REFERENCE"] = "getDataReferenceListAction";
    Actions["GET_EDUCATION"] = "getDataSourceEducationListAction";
    Actions["GET_PROVINCE"] = "getDataSourceProvinceListAction";
    Actions["GET_GENDER"] = "getDataSourceGenderListAction";
})(Actions || (Actions = {}));
export var Mutations;
(function (Mutations) {
    Mutations["SET_DATA_REFERENCE"] = "setDataReferenceMutation";
})(Mutations || (Mutations = {}));
